export default {
	logged:null,
	periodoco:null
}


// WEBPACK FOOTER //
// ./src/store/empresa/state.js